import ScheduledMessagesAPI from '../../api/scheduledMessages';
import types from '../mutation-types';

export const state = {
  records: [],
  uiFlags: { isFetching: false, isCreating: false, isUpdating: false },
};

export const getters = {
  getScheduledMessages: $state => $state.records,
  getPending: $state =>
    $state.records.filter(record => record.status === 'pending'),
  getSent: $state => $state.records.filter(record => record.status === 'sent'),
  getUIFlags: $state => $state.uiFlags,
};

export const actions = {
  async get({ commit }, conversationId) {
    commit(types.SET_SCHEDULED_MESSAGE_UI_FLAG, { isFetching: true });
    try {
      const { data } = await ScheduledMessagesAPI.get(conversationId);
      commit(types.SET_SCHEDULED_MESSAGES, data.payload);
    } finally {
      commit(types.SET_SCHEDULED_MESSAGE_UI_FLAG, { isFetching: false });
    }
  },

  async create({ commit }, { conversationId, ...payload }) {
    commit(types.SET_SCHEDULED_MESSAGE_UI_FLAG, { isCreating: true });
    try {
      const { data } = await ScheduledMessagesAPI.schedule(
        conversationId,
        payload
      );
      commit(types.ADD_SCHEDULED_MESSAGE, data);
      return data;
    } finally {
      commit(types.SET_SCHEDULED_MESSAGE_UI_FLAG, { isCreating: false });
    }
  },

  async update({ commit }, { conversationId, id, ...payload }) {
    commit(types.SET_SCHEDULED_MESSAGE_UI_FLAG, { isUpdating: true });
    try {
      const { data } = await ScheduledMessagesAPI.update(
        conversationId,
        id,
        payload
      );
      commit(types.UPDATE_SCHEDULED_MESSAGE, data);
      return data;
    } finally {
      commit(types.SET_SCHEDULED_MESSAGE_UI_FLAG, { isUpdating: false });
    }
  },

  async cancel({ commit }, { conversationId, id }) {
    await ScheduledMessagesAPI.cancel(conversationId, id);
    commit(types.DELETE_SCHEDULED_MESSAGE, id);
  },

  async sendNow({ commit }, { conversationId, id }) {
    const { data } = await ScheduledMessagesAPI.sendNow(conversationId, id);
    commit(types.UPDATE_SCHEDULED_MESSAGE, data);
  },
};

export const mutations = {
  [types.SET_SCHEDULED_MESSAGE_UI_FLAG]($state, flags) {
    $state.uiFlags = { ...$state.uiFlags, ...flags };
  },
  [types.SET_SCHEDULED_MESSAGES]($state, records) {
    $state.records = records;
  },
  [types.ADD_SCHEDULED_MESSAGE]($state, record) {
    $state.records = [record, ...$state.records];
  },
  [types.UPDATE_SCHEDULED_MESSAGE]($state, record) {
    $state.records = $state.records.map(item =>
      item.id === record.id ? record : item
    );
  },
  [types.DELETE_SCHEDULED_MESSAGE]($state, id) {
    $state.records = $state.records.filter(item => item.id !== id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
